'use strict';

var Sugar = require('sugar-core');

require('./build/buildDateUnitMethodsCall');

module.exports = Sugar.Date.endOfDay;


// WEBPACK FOOTER //
// ./~/sugar-date/date/endOfDay.js